import Typography from '@mui/material/Typography';

export function BookingSupportPage() {
  return <Typography variant="h4">Booking Support Placeholder</Typography>;
}
